<template>
	<div class="form-kickoff-modal form" :class="{ 'nitea-modal-inner': isModalMode }">
		<div class="form-kickoff-repost-card form-inner">

			<!-- Formulär-header endast i modal-läge -->
			<div v-if="isModalMode" class="form-header-container flex-row flex-align-center flex-justify-between">
				<button type="button" class="nitea-modal-close nitea-button is-primary is-outlined is-width-auto is-size-small has-icon-only" @click="closeModal()" aria-label="Stäng">
					<span class="icon-close icon--small"></span>
				</button>
				<div v-if="formTitle || formDescription" class="form-header">
					<template v-if="formTitle || (formDescription && mailSentStatus == null)">
						<h2 v-if="formTitle" class="form-title has-medium-font-size">{{ formTitle }}</h2>
						<p v-if="formDescription" class="form-description">{{ formDescription }}</p>
					</template>
				</div>
			</div>

			<div v-if="mailSentStatus == 'sent'">
				<h2 class="form-section-title has-large-font-size font-weight-medium">Tack!</h2>
				<p>Ditt meddelande har skickats!</p>
			</div>
			<div v-else-if="mailSentStatus == 'error'">
				<h2 class="form-section-title has-large-font-size font-weight-medium">Förlåt!</h2>
				<p>Men ditt meddelande kunde inte skickas! Vänligen ring oss</p>
			</div>

			<form v-if="mailSentStatus === null || mailSentStatus === 'sending'" class="form-container">

					<!-- Kontaktuppgifter -->
					<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">1. Kontaktuppgifter *</h2>
					<div class="form-grid">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.firstName.$dirty && $v.fields.firstName.$error,
								'has-success': $v.fields.firstName.$dirty && !$v.fields.firstName.$error && fields.firstName && fields.firstName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-firstname'" placeholder=" " v-model="fields.firstName" @blur="$v.fields.firstName.$touch()" required="required" />
							<label :for="blockId + '-firstname'" class="floating-label">Förnamn</label>
							<div v-if="$v.fields.firstName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt förnamn</div>
							</div>
						</div>

						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.lastName.$dirty && $v.fields.lastName.$error,
								'has-success': $v.fields.lastName.$dirty && !$v.fields.lastName.$error && fields.lastName && fields.lastName.length > 0,
							}"
						>
							<input type="text" :id="blockId + '-lastname'" placeholder=" " v-model="fields.lastName" @blur="$v.fields.lastName.$touch()" required="required" />
							<label :for="blockId + '-lastname'" class="floating-label">Efternamn</label>
							<div v-if="$v.fields.lastName.$error" class="validation-messages">
								<div class="validation-message error">Vänligen ange ditt efternamn</div>
							</div>
						</div>
					</div>
				</div>

					<!-- Vill du delta? -->
					<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">2. Vill du delta? *</h2>
					<div class="form-section">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.wantsToParticipate.$dirty && $v.fields.wantsToParticipate.$error,
								'has-success': $v.fields.wantsToParticipate.$dirty && !$v.fields.wantsToParticipate.$error && fields.wantsToParticipate && fields.wantsToParticipate.length > 0,
							}"
						>
							<select :id="blockId + '-wants-to-participate'" v-model="fields.wantsToParticipate" @blur="$v.fields.wantsToParticipate.$touch()" required="required">
								<option value="">Välj</option>
								<option value="Ja">Ja</option>
								<option value="Nej">Nej</option>
							</select>
							<label :for="blockId + '-wants-to-participate'" class="floating-label">Vill du delta?</label>
							<div v-if="$v.fields.wantsToParticipate.$error" class="validation-messages">
								<div class="validation-message error">Vänligen välj om du vill delta</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Anläggningsval (alltid obligatoriskt om det finns anläggningar konfigurerade) -->
				<div v-if="facilityRecipients.length > 0" class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">
						3. {{ facilityFieldLabel }}<span> *</span>
					</h2>
					<div class="form-section">
						<div
							class="form-group floating-label"
							:class="{
								'has-error': $v.fields.facility.$dirty && $v.fields.facility.$error,
								'has-success': $v.fields.facility.$dirty && !$v.fields.facility.$error && fields.facility && fields.facility.length > 0,
							}"
						>
							<select
								:id="blockId + '-facility'"
								v-model="fields.facility"
								@blur="$v.fields.facility.$touch()"
								required="required"
							>
								<option value="">{{ facilityFieldLabel }}</option>
								<option v-for="facility in facilityRecipients" :key="facility.id" :value="facility.id">
									{{ facility.name }}
								</option>
							</select>
							<label :for="blockId + '-facility'" class="floating-label">{{ facilityFieldLabel }}</label>
							<div v-if="$v.fields.facility.$error" class="validation-messages">
								<div class="validation-message error">Vänligen välj en anläggning</div>
							</div>
						</div>
					</div>
				</div>

				<!-- Specialkost -->
				<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">{{ facilityRecipients.length > 0 ? '4' : '3' }}. Specialkost</h2>
					<div class="form-section">
						<div
							class="form-group floating-label"
							:class="{
							}"
						>
							<textarea :id="blockId + '-special-diet'" placeholder=" " v-model="fields.specialDiet" class="form-textarea"></textarea>
							<label :for="blockId + '-special-diet'" class="floating-label">Specialkost</label>
						</div>
					</div>
				</div>

				<!-- Övrigt -->
				<div class="form-grid-wrapper">
					<h2 class="form-section-title has-medium-font-size font-weight-medium">{{ facilityRecipients.length > 0 ? '5' : '4' }}. Övrigt</h2>
					<div class="form-section">
						<div
							class="form-group floating-label"
							:class="{
							}"
						>
							<textarea :id="blockId + '-message'" placeholder=" " v-model="fields.message" class="form-textarea"></textarea>
							<label :for="blockId + '-message'" class="floating-label">Övrigt meddelande</label>
						</div>
					</div>
				</div>

			

			

				<div class="form-footer">
					<div class="radio-group"
						:class="{
							'has-error': $v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$error
						}"
					>
						<input type="checkbox" :id="blockId + '-privacy-policy'" v-model="fields.privacyPolicy" @change="$v.fields.privacyPolicy.$touch()" />
						<label :for="blockId + '-privacy-policy'" class="has-caption-font-size">Jag accepterar <a href="/integritetspolicy/" target="_blank" class="has-caption-font-size">integritetspolicyn</a></label>
						<div v-if="$v.fields.privacyPolicy.$dirty && $v.fields.privacyPolicy.$error" class="validation-messages">
							<div class="validation-message error">Du måste acceptera integritetspolicyn</div>
						</div>
					</div>
					<button
						type="button"
						:class="{
							'is-loading': mailSentStatus === 'sending',
							'is-disabled': isFormDisabled,
							'is-filled': !isFormDisabled && !mailSentStatus,
						}"
						class="nitea-button is-primary is-width-auto is-size-default"
						@click="submitForm()"
						:disabled="isFormDisabled"
					>
						Skicka
					</button>
				</div>
			</form>
		</div>
	</div>
</template>

<script>
	import { required, requiredIf } from "vuelidate/lib/validators";

	const mustBeTrue = (value) => value === true;

	export default {
		name: "form-kickoff",
		props: {
			postId: {
				type: Number,
				default: null,
			},
			isModalOpen: {
				type: Boolean,
				default: false,
			},
			formTitle: {
				type: String,
				default: "",
			},
			formDescription: {
				type: String,
				default: "",
			},
			blockId: {
				type: String,
				default: "form-kickoff",
			},
			emailRecipients: {
				type: String,
				default: "",
			},
			emailSubject: {
				type: String,
				default: "",
			},
			facilityRecipients: {
				type: Array,
				default: () => [],
			},
			facilityFieldLabel: {
				type: String,
				default: "Välj anläggning",
			},
			facilityFieldRequired: {
				type: Boolean,
				default: true,
			},
		},
		data() {
			return {
				mailSentStatus: null,
			fields: {
				firstName: "",
				lastName: "",
				privacyPolicy: false,
				facility: "",
				specialDiet: "",
				message: "",
				wantsToParticipate: "",
			},
				// Lokala kopior av props för att undvika mutation
				localEmailRecipients: this.emailRecipients,
				localEmailSubject: this.emailSubject,
			};
		},
		computed: {
			isModalMode() {
				// Om isModalOpen är true, är det modal-läge, Annars är det embedded-läge
				return this.isModalOpen;
			},
			isFormDisabled() {
				// Formuläret är disabled om:
				// 1. Meddelande skickas för närvarande
				// 2. Formuläret är ogiltigt (saknade obligatoriska fält)
				
				return this.mailSentStatus === "sending" || this.$v.fields.$invalid;
			},
			selectedFacilityRecipients() {
				if (!this.fields.facility || this.facilityRecipients.length === 0) {
					return this.localEmailRecipients;
				}
				
				const selectedFacility = this.facilityRecipients.find(f => f.id === this.fields.facility);
				if (selectedFacility && selectedFacility.recipients && selectedFacility.recipients.length > 0) {
					return selectedFacility.recipients.join(', ');
				}
				
				return this.localEmailRecipients;
			},
		},
		validations: {
			fields: {
				firstName: { required },
				lastName: { required },
				specialDiet: { },
				message: { },
				wantsToParticipate: { required },
				privacyPolicy: { mustBeTrue },
				facility: { required: requiredIf(function() {
					return this.facilityFieldRequired && this.facilityRecipients.length > 0;
				}) }
			},
		},
		watch: {
			// Uppdatera lokala kopior när props ändras
			emailRecipients(newVal) {
				this.localEmailRecipients = newVal;
			},
			emailSubject(newVal) {
				this.localEmailSubject = newVal;
			},
		},
		mounted() {
			// Läs postId från data-attribut om det inte skickats som prop
			if (!this.postId && this.$el && this.$el.hasAttribute("data-post-id")) {
				const postId = this.$el.getAttribute("data-post-id");
				this.postId = postId ? parseInt(postId) : null;
			}

			// Läs formulär-information från data-attribut om det inte skickats som props
			if (!this.formTitle && this.$el && this.$el.hasAttribute("data-form-title")) {
				this.formTitle = this.$el.getAttribute("data-form-title") || "";
			}
			if (!this.formDescription && this.$el && this.$el.hasAttribute("data-form-description")) {
				this.formDescription = this.$el.getAttribute("data-form-description") || "";
			}

			// Läs blockId från data-attribut om det inte skickats som prop
			if (!this.blockId && this.$el && this.$el.hasAttribute("data-block-id")) {
				this.blockId = this.$el.getAttribute("data-block-id") || "form-kickoff";
			}
		},
		methods: {

			closeModal() {
				// Skicka event för att stänga modalen
				window.dispatchEvent(
					new CustomEvent("closeFormModal", {
						detail: { formType: "kickoff" },
					}),
				);
			},
			submitForm() {
				this.$v.$touch();
				if (this.$v.$invalid) {
					return;
				}

				this.mailSentStatus = "sending";

				const formData = new FormData();
				formData.append("action", "nitea_utils_form_post_kickoff");
				formData.append("post_id", this.postId);
				formData.append("first_name", this.fields.firstName);
				formData.append("last_name", this.fields.lastName);
				formData.append("special_diet", this.fields.specialDiet);
				formData.append("message", this.fields.message);
				formData.append("facility", this.fields.facility);
				formData.append("wants_to_participate", this.fields.wantsToParticipate);
				
				// Skicka facilityRecipients så backend kan hitta namnet
				if (this.facilityRecipients.length > 0) {
					formData.append("facility_recipients", JSON.stringify(this.facilityRecipients));
				}

				// Skicka med email-konfiguration från blocket eller vald anläggning
				const recipients = this.selectedFacilityRecipients;
				if (recipients) {
					formData.append("email_recipients", recipients);
				}
				if (this.localEmailSubject) {
					formData.append("email_subject", this.localEmailSubject);
				}

				fetch(window.nitea_utils_forms_kickoff.admin_url + "?action=nitea_utils_form_post_kickoff", {
					method: "POST",
					body: formData,
				})
					.then((response) => response.json())
					.then((data) => {
						if (data.success) {
							this.mailSentStatus = "sent";
							this.resetForm();
						} else {
							this.mailSentStatus = "error";
						}
					})
					.catch((error) => {
						console.error("Error:", error);
						this.mailSentStatus = "error";
					});
			},
		resetForm() {
			this.fields = {
				firstName: "",
				lastName: "",
				specialDiet: "",
				message: "",
				facility: "",
				wantsToParticipate: "",
			};
			this.$v.$reset();
		},
		},
	};
</script>
